export const WS_DDOS_TYPES = {
    // --- Client -> Server ---
    CONNECT_TARGET: 'DDOS_CONNECT_TARGET',   // { ip: string }
    DISCONNECT_TARGET: 'DDOS_DISCONNECT_TARGET',// { ip: string } (Optional: Can rely on WS close)
    START_ATTACK: 'DDOS_START_ATTACK',      // { ip: string, attackConfig: object }
    STOP_ATTACK: 'DDOS_STOP_ATTACK',        // { ip: string }
    GET_STATE: 'DDOS_GET_STATE',          // Client requests current state on reconnect
  
    // --- Server -> Client (User Queue) ---
    // Status/General Updates (/user/queue/ddos/status)
    CONNECTION_STATUS: 'DDOS_CONNECTION_STATUS', // { success: boolean, serverInfo: object | null, error: string | null }
    ATTACK_STARTED: 'DDOS_ATTACK_STARTED',      // { attackType: string, message: string }
    ATTACK_STOPPED: 'DDOS_ATTACK_STOPPED',      // { success: boolean, message: string }
    ATTACK_COMPLETED: 'DDOS_ATTACK_COMPLETED',    // { success: boolean, results: object, protectionAnalysis?: object, message: string }
    CURRENT_STATE: 'DDOS_CURRENT_STATE',        // Response to GET_STATE { isConnected: boolean, serverInfo?: object, attack?: { config: object, status: string, progress: object } }
  
    // Progress Updates (/user/queue/ddos/progress)
    ATTACK_PROGRESS: 'DDOS_ATTACK_PROGRESS',    // { packetsSent: number, dataSent: string, serverPing: number, targetStatus: string, trafficRate: object, serverResponse: object }
  
    // Error Updates (/user/queue/ddos/error)
    ERROR: 'DDOS_ERROR',                    // { message: string, isFatal: boolean, context?: string ('connection', 'attack', etc.) }

    // Captcha Frame Verification
    CAPTCHA_REQUIRED: 'CAPTCHA_REQUIRED',
    INTERACT_CAPTCHA: 'INTERACT_CAPTCHA',
  };
  
  export const WS_DDOS_TOPICS = {
    // --- Destinations for Client Commands ---
    APP_ENDPOINT_BASE: '/ddos',
    CONNECT: '/connect',
    DISCONNECT: '/disconnect',
    START: '/start',
    STOP: '/stop',
    GET_STATE: '/get-state',
    INTERACT_CAPTCHA: '/interact-captcha',
  
    // --- User-Specific Subscription Topics ---
    USER_QUEUE_BASE: '/user/queue/ddos',
    STATUS: '/status',    // For CONNECTION_STATUS, ATTACK_STARTED/STOPPED/COMPLETED, CURRENT_STATE, CAPTCHA_REQUIRED
    PROGRESS: '/progress', // For ATTACK_PROGRESS
    ERROR: '/error',      // For ERROR messages
  };
  
  // Helper to build full app destination path
  export const getAppEndpoint = (action) => `${WS_DDOS_TOPICS.APP_ENDPOINT_BASE}${action}`;
  // Helper to build full user subscription topic path
  export const getUserQueueTopic = (subTopic) => `${WS_DDOS_TOPICS.USER_QUEUE_BASE}${subTopic}`;